import * as React from "react";
import {
  Dialog as MUIDialog,
  DialogProps as MUIDialogProps,
  styled,
} from "@mui/material";

export type DialogProps = MUIDialogProps & {};

const DialogContainer = styled(MUIDialog)(({ theme }) => ({
  "& .MuiDivider-root": {
    my: theme.spacing(2.5),
  },
  "& .MuiDialogContent-root .MuiTypography-root": {
    color: theme.palette.common.grey.gBFBFBF,
  },
}));

const Dialog = (props: DialogProps) => {
  return <DialogContainer {...props}></DialogContainer>;
};
export default Dialog;
